(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slice-vip-reservation"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var scrollButton = document.querySelector('[data-scroll-to-top]');
    
    if (scrollButton) {
      scrollButton.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
